import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import "../styles/Formularios.css";
import "../styles/RastrearRed.css";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";
import InputNombrePuertoSw from "./InputNombrePuertoSw";
import InputNombrePuertoPp from "./InputNombrePuertoPp";
import InputIp from "./InputIp";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function RastrearRed({ setVista }) {
    const { logout } = useGlobal();
    const [radioSeleccionado, setRadioSeleccionado] = useState(null);
    const [datoIngresado, setDatoIngresado] = useState("");
    const [resultado, setResultado] = useState(null);
    const [confirmado, setConfirmado] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [success, setSuccess] = useState(false);
    const apiFetch = useApiFetch();

    // Función genérica para rastrear según endpoint
    const rastrear = async (endpoint) => {
        try {

            const data = await apiFetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ datoIngresado })
            }, logout);

            if (data.status === "ok") {
                setResultado(data.resultado || []);
                setMensaje("");
            } else {
                setMensaje(data.message || "Error en la consulta.");
            }
        } catch (error) {
            setMensaje("Error al conectar con el servidor.");
        }
    };

    // Mapeo de opciones
    const opciones = {
        A: { accion: () => rastrear("rastrear_red_por_puerto_sw.php") },
        B: { accion: () => rastrear("rastrear_red_por_puerto_pp.php") },
        C: { accion: () => rastrear("rastrear_red_por_nodo.php") },
        D: { accion: () => rastrear("rastrear_red_por_ip.php") },
    };

    const exportarCSV = () => {
        if (!resultado) return;

        // Encabezados
        const encabezados = [
            "Puerto Switch",
            "Puerto Patch",
            "Nodo",
            "Tipo de Bien",
            "Serie del Bien",
            "IP",
            "Usuario"
        ];

        // Valores
        const valores = [
            resultado.datoPuertoSw,
            resultado.datoPuertoPp,
            resultado.nodo,
            resultado.tipoBien,
            resultado.serieBien,
            resultado.ip,
            `${resultado.usuario} ${resultado.aPaterno} ${resultado.aMaterno}`
        ];

        // Construir CSV
        const filas = [encabezados.join(","), valores.join(",")];
        const contenido = filas.join("\n");

        // Crear blob con BOM UTF-8 para Excel
        const blob = new Blob(
            ["\uFEFF" + contenido], // BOM, asegura que Excel detecte UTF-8
            { type: "text/csv;charset=utf-8;" }
        );

        // Disparar descarga
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "rastreo_por_elemento.csv";
        link.click();
        URL.revokeObjectURL(url);
    };

    // Exportar en formato PDF
    const exportarPDF = () => {
        if (!resultado) return;

        const doc = new jsPDF();

        // Logo
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de conexión de red", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Campo", "Valor"]],
            body: [
                ["Puerto Switch", resultado.datoPuertoSw],
                ["Puerto Patch Panel", resultado.datoPuertoPp],
                ["Nodo", resultado.nodo],
                ["Tipo de bien", resultado.tipoBien],
                ["Serie del bien", resultado.serieBien],
                ["IP", resultado.ip],
                ["Usuario", `${resultado.usuario} ${resultado.aPaterno} ${resultado.aMaterno}`],
            ],
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("rastreo_red.pdf");
    };

    // Efecto para limpiar el mensaje después de un tiempo establecido
    useEffect(() => {
        if (mensaje) {
            const timer = setTimeout(() => {
                setMensaje("");
                setSuccess(false);
            }, 2000);

            return () => clearTimeout(timer); // Evita comflicto si cambia antes
        }
    }, [mensaje]);

    return (
        <div className="contenedor-dos-columnas">
            {/* Columna izquierda */}
            <div className="columna-izquierda radio-group">

                <h3>Restrear la red por elemento:</h3>

                {/* Radios */}
                <label>
                    <input
                        type="radio"
                        name="opcion"
                        value="A"
                        checked={radioSeleccionado === "A"}
                        onChange={(e) => setRadioSeleccionado(e.target.value)}
                        disabled={confirmado}
                    />
                    Puerto Switch
                </label>

                <label>
                    <input
                        type="radio"
                        name="opcion"
                        value="B"
                        checked={radioSeleccionado === "B"}
                        onChange={(e) => setRadioSeleccionado(e.target.value)}
                        disabled={confirmado}
                    />
                    Puerto Patch Panel
                </label>

                <label>
                    <input
                        type="radio"
                        name="opcion"
                        value="C"
                        checked={radioSeleccionado === "C"}
                        onChange={(e) => setRadioSeleccionado(e.target.value)}
                        disabled={confirmado}
                    />
                    Nodo
                </label>

                <label>
                    <input
                        type="radio"
                        name="opcion"
                        value="D"
                        checked={radioSeleccionado === "D"}
                        onChange={(e) => setRadioSeleccionado(e.target.value)}
                        disabled={confirmado}
                    />
                    Ip
                </label>

                {/* Botón continuar solo con radios */}
                {radioSeleccionado && !confirmado && (
                    <button onClick={() => setConfirmado(true)}>Continuar</button>
                )}

                {/* Input y botones solo después de confirmar */}
                {confirmado && (
                    <>
                        {radioSeleccionado === "A" && (
                            <div className="input-elemento">
                                <InputNombrePuertoSw
                                    value={datoIngresado}
                                    setValue={setDatoIngresado}
                                    label="Nombre del puerto switch"
                                    title="Formato: sw1_ep_p1_10, máximo 12 caracteres."
                                />
                            </div>
                        )}

                        {radioSeleccionado === "B" && (
                            <div className="input-elemento">
                                <InputNombrePuertoPp
                                    value={datoIngresado}
                                    setValue={setDatoIngresado}
                                    label="Nombre del puerto patch panel"
                                    title="Formato: pp1_ep_p1_10, máximo 12 caracteres."
                                />
                            </div>
                        )}

                        {radioSeleccionado === "C" && (
                            <div className="input-elemento">
                                <InputGenerico
                                    value={datoIngresado}
                                    setValue={setDatoIngresado}
                                    label="Ingrese Nodo"
                                    readOnly={false}
                                    maxLength={3}
                                    allowedChars="0-9"
                                    transform="uppercase"
                                    placeholder="Ejemplo: 101"
                                    title="Respete la nomenclatura"
                                />
                            </div>
                        )}

                        {radioSeleccionado === "D" && (
                            <div className="input-elemento">
                                <InputIp
                                    value={datoIngresado}
                                    setValue={setDatoIngresado}
                                    label="Dirección IP"
                                    title="Ingrese una IP válida"
                                    readOnly={false}
                                />
                            </div>
                        )}

                        <div className="form-buttons">
                            <button
                                onClick={() => {
                                    if (opciones[radioSeleccionado]) {
                                        opciones[radioSeleccionado].accion();
                                    }
                                }}
                            >
                                Continuar
                            </button>

                            <button
                                onClick={() => {
                                    setRadioSeleccionado(null);
                                    setDatoIngresado("");
                                    setResultado(null);
                                    setConfirmado(false);
                                }}
                            >
                                Limpiar
                            </button>
                        </div>
                    </>
                )}

                {mensaje && <div className="error">{mensaje}</div>}

            </div>

            {/* Columna derecha SOLO si hay resultado */}
            {
                resultado && (
                    <div className="columna-derecha form-buttons">
                        <div className="tabla-resultados">
                            <h3>Detalle de conexión</h3>
                            <table className="tabla-estandar">
                                <tbody>
                                    <tr><th>Puerto Switch</th><td>{resultado.datoPuertoSw}</td></tr>
                                    <tr><th>Puerto Patch Panel</th><td>{resultado.datoPuertoPp}</td></tr>
                                    <tr><th>Nodo</th><td>{resultado.nodo}</td></tr>
                                    <tr><th>Tipo de bien</th><td>{resultado.tipoBien}</td></tr>
                                    <tr><th>Serie del bien</th><td>{resultado.serieBien}</td></tr>
                                    <tr><th>IP</th><td>{resultado.ip}</td></tr>
                                    <tr><th>Usuario</th><td>{resultado.usuario} {resultado.aPaterno} {resultado.aMaterno}</td></tr>
                                </tbody>
                            </table>
                        </div>

                        <button onClick={exportarCSV}>Exportar<br></br>en CSV</button>
                        <button onClick={exportarPDF}>Exportar<br></br>en PDF</button>
                    </div>
                )
            }

        </div >
    );
}

export default RastrearRed;